<template>
  <!-- 电商带货 -->
  <div class="goodsContainer">
    <div class="part1">
      <div class="top">
        <h5>带货数据</h5>
        <el-radio-group class="tab clear" v-model="tab1Position" @change="tab1Click">
          <el-radio-button label="day7">近7天</el-radio-button>
          <el-radio-button label="day30">近30天</el-radio-button>
          <el-radio-button label="day90">近90天</el-radio-button>
        </el-radio-group>  
      </div>
      <span class="title2">重点数据</span>
      <ul class="clear">
          <li>
              <span>{{getKsCommerce.videoCnt?getKsCommerce.videoCnt:"-"}}</span>
              <p>带货视频数</p>
          </li>
          <li>
              <span>{{getKsCommerce.videoPlayCntMedian?getKsCommerce.videoPlayCntMedian:"-"}}</span>
              <p>播放量中位数<i></i></p>
          </li>
          <li>
              <span>{{getKsCommerce.goodsCnt?getKsCommerce.goodsCnt:"-"}}</span>
              <p>带货商品数<i></i></p>
          </li>
          
      </ul>
      <span class="title2">热销TOP品牌</span>
      <div class="hot_brand">
        <ul class="clear">
          <li v-show="darenInfo.hotBrandInfo.length===0">无</li>
          <li v-for="(item,i) in darenInfo.hotBrandInfo" :key="i">
            <i>{{i+1}}</i><span>{{item.hotSaleBrandTitle}}</span>
          </li>
        </ul>
      </div>
      <span class="title2">优势类目</span>
      <div class="hot_channel">
        <li v-show="darenInfo.hotChannelInfo.length===0" style="margin-top:20px;">无</li>
        <ul class="clear">
          <li v-for="(item,i) in darenInfo.hotChannelInfo" :key="i">
            <i>{{i+1}}</i>
            <span>{{item.hotSaleChannelTitle}}</span>
            <u>{{item.hotSaleChannelRate}}%</u>
          </li>
        </ul>
      </div>
      <span class="title2">带货分析</span>
      <div class="noData" v-show="noData">
        <img src="../images/noData3.png" alt="">
        <span>暂无带货分析数据</span>
      </div>
      <span class="title3" v-show="!noData">商品价格在{{goodChartTitleData.cur.name}}，带货量最高为{{goodChartTitleData.cur.value}}件</span>
      <BarChart v-show="!noData" :barChartInfo="goodChartData.day7" ref="goodChart"></BarChart>
    </div>
    
  </div> 
</template>

<script>
import tools from "../../../components/tools/tools.js";
import BarChart from '../../../components/Echart/BarChart.vue';
export default {
  name: "Goods",
  props:["darenID"],
  data(){
    return {
      tab1Position:"day7",
      getKsCommerce:{},
      changeKsCommerce:{
        day7:{},
        day30:{},
        day90:{}
      },
      noData:true,
      goodChartData:{
        day7:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        },
        day30:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        },
        day90:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        }
      },
      goodChartTitleData:{
        cur:{name:"-元",value:"-"},
        day7:{},
        day30:{},
        day90:{}
      },
      darenInfo:{
        hotChannelInfo:[],
        hotBrandInfo:[]
      }
    }
  },
  computed:{
    
  },
  methods:{
    tab1Click(tab){
      if(tab==="day7"){
        this.tab1Position = "day7"
        this.getKsCommerce = this.changeKsCommerce.day7
        this.$refs.goodChart.barChart(this.goodChartData.day7)
        this.noData=(this.goodChartData.day7.data.length)>0?false:true
        this.goodChartTitleData.cur = this.goodChartTitleData.day7
      }else if(tab==="day30"){
        this.tab1Position = "day30"
        if(window.sessionStorage.getItem('getKsCommerce30')){
          this.initGetKsCommerce30(JSON.parse(window.sessionStorage.getItem('getKsCommerce30')))
          this.getKsCommerce = this.changeKsCommerce.day30
          this.$refs.goodChart.barChart(this.goodChartData.day30)
          this.noData=(this.goodChartData.day30.data.length)>0?false:true
          this.goodChartTitleData.day30={value:tools.arrayMax(this.goodChartData.day30.data),name:this.goodChartData.day30.xAxisData[tools.arrayMax(this.goodChartData.day30.data,"index")]}
          this.goodChartTitleData.cur = this.goodChartTitleData.day30
        }else{
          this.$api.getKuaishouData.getKsCommerce('/'+this.darenID,"duration=30").then((res) => {
            window.sessionStorage.setItem('getKsCommerce30',JSON.stringify(res))
            this.initGetKsCommerce30(res)
            this.getKsCommerce = this.changeKsCommerce.day30
            this.$refs.goodChart.barChart(this.goodChartData.day30)
            this.noData=(this.goodChartData.day30.data.length)>0?false:true
            this.goodChartTitleData.day30={value:tools.arrayMax(this.goodChartData.day30.data),name:this.goodChartData.day30.xAxisData[tools.arrayMax(this.goodChartData.day30.data,"index")]}
            this.goodChartTitleData.cur = this.goodChartTitleData.day30
          })
        }
      }else if(tab==="day90"){
        this.tab1Position = "day90"
        if(window.sessionStorage.getItem('getKsCommerce90')){
          this.initGetKsCommerce90(JSON.parse(window.sessionStorage.getItem('getKsCommerce90')))
          this.getKsCommerce = this.changeKsCommerce.day90
          this.$refs.goodChart.barChart(this.goodChartData.day90)
          this.noData=(this.goodChartData.day90.data.length)>0?false:true
          this.goodChartTitleData.day90={value:tools.arrayMax(this.goodChartData.day90.data),name:this.goodChartData.day90.xAxisData[tools.arrayMax(this.goodChartData.day90.data,"index")]}
          this.goodChartTitleData.cur = this.goodChartTitleData.day90
        }else{
          this.$api.getKuaishouData.getKsCommerce('/'+this.darenID,"duration=90").then((res) => {
            window.sessionStorage.setItem('getKsCommerce90',JSON.stringify(res))
            this.initGetKsCommerce90(res)
            this.getKsCommerce = this.changeKsCommerce.day90
            this.$refs.goodChart.barChart(this.goodChartData.day90)
            this.noData=(this.goodChartData.day90.data.length)>0?false:true
            this.goodChartTitleData.day90={value:tools.arrayMax(this.goodChartData.day90.data),name:this.goodChartData.day90.xAxisData[tools.arrayMax(this.goodChartData.day90.data,"index")]}
            this.goodChartTitleData.cur = this.goodChartTitleData.day90
          })
        }
      }
    },
    initGetKsCommerce7(res){
      let getKsCommerce= res.data.data
      let goodChartData ={
        day7:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        }
      }
      getKsCommerce.videoPlayCntMedian=tools.setThousands(getKsCommerce.videoPlayCntMedian)
      getKsCommerce.goodsGraph.map(item=>{
        goodChartData.day7.data.push(item.cnt)
        goodChartData.day7.xAxisData.push(item.range+"元")
      })
      this.goodChartData.day7 = goodChartData.day7
      this.changeKsCommerce.day7 = getKsCommerce
      this.goodChartTitleData.day7={value:tools.arrayMax(this.goodChartData.day7.data),name:this.goodChartData.day7.xAxisData[tools.arrayMax(this.goodChartData.day7.data,"index")]}
      this.goodChartTitleData.cur = this.goodChartTitleData.day7
    },
    initGetKsCommerce30(res){
      let getKsCommerce= res.data.data
      let goodChartData ={
        day30:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        }
      }
      getKsCommerce.videoPlayCntMedian=tools.setThousands(getKsCommerce.videoPlayCntMedian)
      getKsCommerce.goodsGraph.map(item=>{
        goodChartData.day30.data.push(item.cnt)
        goodChartData.day30.xAxisData.push(item.range+"元")
      })
      this.goodChartData.day30 = goodChartData.day30
      this.changeKsCommerce.day30 = getKsCommerce
    },
    initGetKsCommerce90(res){
      let getKsCommerce= res.data.data
      let goodChartData ={
        day90:{
          nodeId:'goodChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '带货数',
          unit:'件'
        }
      }
      getKsCommerce.videoPlayCntMedian=tools.setThousands(getKsCommerce.videoPlayCntMedian)
      getKsCommerce.goodsGraph.map(item=>{
        goodChartData.day90.data.push(item.cnt)
        goodChartData.day90.xAxisData.push(item.range+"元")
      })
      this.goodChartData.day90 = goodChartData.day90
      this.changeKsCommerce.day90 = getKsCommerce
    }
  },
  components:{
    BarChart
  },
  watch:{
    
  },
  created(){
    // 达人带货数据
    if(window.sessionStorage.getItem('getKsCommerce7')){
        this.initGetKsCommerce7(JSON.parse(window.sessionStorage.getItem('getKsCommerce7')))
        this.getKsCommerce = this.changeKsCommerce.day7
    }else{
      this.$api.getKuaishouData.getKsCommerce('/'+this.darenID,"duration=7").then((res) => {
        window.sessionStorage.setItem('getKsCommerce7',JSON.stringify(res))
        this.initGetKsCommerce7(res)
        this.getKsCommerce = this.changeKsCommerce.day7
        this.$refs.goodChart.barChart(this.goodChartData.day7)
      })
    }
    //达人基础数据
    this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsProfile')).data.data
  },
  mounted() {
    if(window.sessionStorage.getItem('getKsCommerce7')){
      this.noData=(this.goodChartData.day7.data.length)>0?false:true
      this.$refs.goodChart.barChart(this.goodChartData.day7)
    }
  }
}
</script>

<style scoped>
  #goodChart{
    margin-top: 10px;
    width: 804px;
    height: 266px;
  }
  .title2{
    display: block;
    margin-top: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .title3{
    display: block;
    margin-top: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #777;
  }
  .noData{
    width: 100%;
    min-height: 160px;
    position: relative;
  }
  .noData img{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: inline-block;
    width: 48px;
    height: 48px;
  }
  .noData span{
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    margin: 0 auto;
    font-size: 16px;
    text-align: center;
    color: #999;
  }

  #detailedData{
    margin-top: 0px;
    width: 804px;
    height: 286px;
  }
  .goodsContainer{
    width: 864px;
  }
  .goodsContainer .part1{
    width: 864px;
    /* height: 550px; */
    padding: 0 30px 50px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .goodsContainer .top{
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
  .goodsContainer .top h5{
    display: inline-block;
    height: 76px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .goodsContainer .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .goodsContainer .top .tab{
    float: right;
    margin-left: 16px;
    margin-top: 22px;
  }
 

  .goodsContainer .part1 ul{
      width: 100%;
      height: 100px;
      margin: 0;
      padding: 30px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #F0F0F0;
  }
  .goodsContainer .part1 ul li{
      float: left;
      width: 33%;
      height: 100%;
      border-right: 1px solid #F0F0F0;
      list-style:none;
      text-align: center;
      box-sizing: border-box;
  }
  .goodsContainer .part1 ul li:nth-of-type(3){
      border: 0;
  }
  .goodsContainer .part1 ul li span{
      font-size: 18px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #333333;
  }
  .goodsContainer .part1 ul li p{
      position: relative;
      margin-top: 4px;
      margin-left: -14px;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #666666;
      text-align: center;
  }
  .goodsContainer .part1 ul li p i{
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      margin-left: 6px;
      width: 14px;
      height: 14px;
      cursor: pointer;
      background: url("../images/icon_6.png") no-repeat center;
  }
  .goodsContainer .top1.top{
    border-bottom: 0;
  }
  .goodsContainer .top1.top h5{
    float: left;
    height: 100%;
    margin: 0;
    font-size: 14px;
    line-height: 76px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    bottom: 0;
  }
  .goodsContainer .part1 .goodData{
    width: 100%;
    background: cornflowerblue;
    font-size: 12px;
    border-bottom: 1px solid #f5f5f5;
  }
  .goodsContainer .part1 .goodData ul{
    padding: 0;
    border: 0;
    margin: 0;
  }
  .goodsContainer .part1 .goodData ul li{
    width: 20%;
    padding: 0;
    border-right: 0!important;
    border-bottom: 1px solid #f5f5f5;
    margin: 0;
  }
  .goodsContainer .part1 .goodData ul{
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-weight: 700;
    background: #fff;
  }
  .goodsContainer .part1 .goodData ul:nth-of-type(1){
    background: #f5f5f5;
    height: 40px;
    line-height: 40px;
  }
  
  .goodsContainer .part1 .goodData ul li img{
    display: block;
    margin-top: 10px;
    width: 60px;
    height: 60px;

  }
  .goodsContainer .part1 .goodData ul li:nth-of-type(1){
    position: relative;
    width: 35%;
  }
  .goodsContainer .part1 .goodData ul li:nth-of-type(3){
    width: 5%;
  }
  .goodsContainer .part1 .goodData ul li:nth-of-type(3){
    width: 5%;
  }
  .goodsContainer .part1 .goodData ul li span{
    position: absolute;
    top: 20px;
    left: 80px;
    width: 220px;
    height: 40px;
    line-height: 20px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    color: #2c3e50;
  }

  .goodsContainer .goodVideo {
    width: 100%;
    /* width: 864px;
    padding: 0 30px; */
    background: #FFFFFF;
    
  }

  .goodsContainer .goodVideo .goodVideoList {
      padding: 0;
      width: 100%;
      height: auto;
      overflow: hidden;
  }

  .goodsContainer .goodVideo .goodVideoList li {
      width: 100%;
      height: 222px;
      /* margin: 30px 0; */
      padding: 30px 0;
      overflow: hidden;
      border: 0;
      border-top: 1px solid #F0F0F0;
  }

  .goodsContainer .goodVideo .goodVideoList .goodVideoLeft {
      position: relative;
      float: left;
      width: 118px;
      height: 162px;
      border-radius: 4px;
      overflow: hidden;
  }
  .goodsContainer .goodVideo .goodVideoList .backWrap.active {
    display: none;
  }
  .goodsContainer .goodVideo .goodVideoList .goodVideoLeft video{
    width: 100%;
    position: absolute;
  }

  .goodsContainer .goodVideo .goodVideoList .goodVideoLeft .backWrap {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .2);
  }

  /* .goodVideo .goodVideoList .goodVideoLeft .backWrap img { */
  .goodVideo .goodVideoList .goodVideoLeft .backWrap::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      content: "";
      width: 27px;
      height: 31px;
      background: url("../images/icon_play.png") center;
      background-size: cover;
  }

  .goodVideo .goodVideoList .goodVideoLeft img {
      display: block;
      top: 0;
      width: 100%;
      height: 100%;
  }

  .goodVideo .goodVideoList .goodVideoRight {
      float: left;
      width: 660px;
      height: 100%;
      margin-left: 20px;
  }

  .goodVideo .goodVideoList .goodVideoRight p {
      margin: 0;
      margin-bottom: 5px;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
      text-align: left;
  }

  .goodVideo .goodVideoList .goodVideoRight span {
      position: unset;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #666666;
  }

  .goodVideo .goodVideoList .goodVideoRight .tag {
      width: 100%;
      overflow: hidden;
      margin-top: 14px;
  }

  .goodVideo .goodVideoList .goodVideoRight .tag span {
      float: left;
      position: relative;
      height: 34px;
      margin-right: 10px;
      padding: 0 14px;
      padding-left: 34px;
      line-height: 34px;
      background: #EDFAF3;
      border-radius: 4px;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #31C270;
      top: auto;
  }

  .goodVideo .goodVideoList .goodVideoRight .tag span i {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 16px;
      margin: auto 0;
      width: 12px;
      height: 12px;
      background: url("../images/icon_pag.png");
  }

  .goodVideo .goodVideoList .goodVideoRight .goodVideoItem {
      float: left;
      width: 220px;
      margin-top: 16px;
  }

  .goodVideo .goodVideoList .goodVideoRight .goodVideoItem span {
      display: block;
      margin-bottom: 6px;
      font-size: 20px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #333333;
      text-align: left;
  }

  .goodVideo .goodVideoList .goodVideoRight .goodVideoItem i {
      display: block;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #333333;
  }

  .goodVideo .hr {
      width: 100%;
      height: 1px;
      background: #F0F0F0;
  }
      .alertVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.5);
  }
  .alertVideo .videoCard{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 8px;
    width: 820px;
    height: 646px;
    background: #fff;
    border-radius: 6px;
  }
  .alertVideo .videoCard .videoBox{
    float: left;
    width: 363px;
    height: 644px;
    border-radius: 4px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoBox video{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo{
    float: right;
    width: 390px;
    height: 100%;
    margin-right: 20px;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop{
    margin-top: 30px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo{
    float: left;
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo img{
    width: 100%;
    height: 100%;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name{
    float: left;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name p{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name i{
    display: inline-block;
    margin-right: 6px;
    color: #999;
    font-size: 14px;
    
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name b{
    display: inline-block;
    color: #666;
    font-size: 14px;
  }
  .alertVideo .videoCard .videoInfo .tag{
    margin: 40px 0;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .tag span{
    float: left;
    color: #333;
    font-size: 14px;
    padding: 3px 8px;
    background: #eee;
    border-radius: 4px;
    margin-right: 8px;
  }
  .alertVideo .videoCard .videoInfo p{
    width: 100%;
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #333;
  }
  .alertVideo .videoCard .videoInfo .other{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo .other i{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 10px;
    line-height: 18px;
    background: url("../images/icon_1.png") no-repeat center bottom;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(1){
    background-image: url("../images/icon_3.png");
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .alertVideo .videoCard .videoInfo .other b{
    display: inline-block;
    margin-right: 20px;
    font-size: 16px;
    color: #333;
    line-height: 18px;
  }
  .alertVideo .close{
    position: absolute;
    top:40px;
    right: 40px;
    width: 21px;
    height: 21px;
    background: url("../images/close.png") no-repeat center;
    cursor: pointer;
  }
  .videoCard .bottom{
    position: absolute;
    bottom: 20px;
    right: 30px;
  }
  .videoCard .bottom a{
    display: inline-block;
    margin-left: 10px;
    color: #38a1ff;
    font-size: 12px;
  }
  .goodsContainer .part1 .hot_brand ul,
  .goodsContainer .part1 .hot_channel ul{
    height: auto;
  }
  .goodsContainer .part1 .hot_brand ul li,
  .goodsContainer .part1 .hot_channel ul li{
    width: auto;
    border:0;
  }
  .goodsContainer .part1 .hot_brand ul{
    padding-top: 30px;
    padding-bottom: 10px;
  }
  .goodsContainer .part1 .hot_brand ul li{
    float: left;
    height: 18px;
    margin-right: 40px;
    margin-bottom: 20px;
  }
  .goodsContainer .part1 .hot_brand ul li i{
    display: inline-block;
    margin-right: 8px;
    padding: 0 5px;
    height: 18px;
    font-size: 12px;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 18px;
    background: #BFBFBF;
    border-radius: 2px 6px 6px 6px;
  }
  .goodsContainer .part1 .hot_brand ul li:nth-of-type(1) i{
    background: #F02D2D;
  }
  .goodsContainer .part1 .hot_brand ul li:nth-of-type(2) i{
    background: #FF6612;
  }
  .goodsContainer .part1 .hot_brand ul li:nth-of-type(3) i{
    background: #FFAE00;
  }
  .goodsContainer .part1 .hot_brand ul li span{
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .goodsContainer .part1 .hot_channel ul{
    padding-bottom: 0;
  }
  .goodsContainer .part1 .hot_channel ul li{
    float: left;
    width: 240px;
    height: 60px;
    margin-right: 16px;
    background: #FAFAFA;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 16px 20px;
    box-sizing: border-box;
  }
  .goodsContainer .part1 .hot_channel ul li:nth-of-type(3n){
    margin-right: 0;
  }
  .goodsContainer .part1 .hot_channel ul li i{
    float: left;
    width: 26px;
    height: 24px;
    margin-right: 10px;
    background: salmon;
    line-height: 26px;
    text-align: center;
    font-size: 12px;
    font-weight: 800;
    background-size: cover;
    color: #fff;
    background: #BFBFBF;
    border-radius: 4px;
  }
  .goodsContainer .part1 .hot_channel ul li:nth-of-type(1) i{
    background: url("../images/top1.png") no-repeat top center;
    font-size: 0;
  }
  .goodsContainer .part1 .hot_channel ul li:nth-of-type(2) i{
    background: url("../images/top2.png") no-repeat top center;
    font-size: 0;
  }
  .goodsContainer .part1 .hot_channel ul li:nth-of-type(3) i{
    background: url("../images/top3.png") no-repeat top center;
    font-size: 0;
  }
  .goodsContainer .part1 .hot_channel ul li span{
    float: left;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
  }
  .goodsContainer .part1 .hot_channel ul li u{
    float: right;
    font-size: 14px;
    font-weight: 800;
    color: #333333;
    line-height: 28px;
  }

</style>